export const ClientMessage = (json: IClientMessage): IClientMessageModel => {
	const { type, subject, content, client_uuid, created_at, ...rest } = json

	return {
		...rest,
		type,
		subject,
		content,
		clientUUID: client_uuid,
		createdAT: created_at,
	}
}

export const ClientMessageManageToJson = (obj: IClientMessageCreateModel): IClientMessageCreateModel => {
	const { client_uuid, type, subject, content } = obj

	return {
		client_uuid,
		type,
		subject,
		content,
	}
}
